import { defineStore } from 'pinia'
import { ref } from 'vue'
import { HotelRoomInfoVO, ELongHotelDetailDTO, HotelRoomPriceVO } from '@/service/hotel/hotel.d'

/**
 * 扩展类型，包含房型基础信息和价格套餐信息
 * 用于存储 /query/hotel/rate 接口返回的完整数据
 * 包含所有字段如：saleScenarioPackage, roomRateList, refundableList 等
 */
type HotelRoomWithRate = Partial<HotelRoomInfoVO & HotelRoomPriceVO>

export const useHotelFillOrder = defineStore('hotelFillOrder', () => {
  const selHotelRoom = ref<HotelRoomWithRate>({}) // 选中的酒店房型（包含价格套餐信息）
  const rpIndex = ref(0) // 选中的酒店房型的RP的索引
  const hotelDetail = ref<ELongHotelDetailDTO>({}) // 酒店详情
  const isClickRoomTypeBut = ref(false) // 是否点击查看房型按钮

  const setSelHotelRoom = (val: HotelRoomWithRate) => {
    // 使用深拷贝确保所有字段都被保留，包括 saleScenarioPackage 等
    selHotelRoom.value = { ...val }
  }
  const setRpIndex = (val: number) => {
    rpIndex.value = val
  }
  const setHotelDetail = (val: ELongHotelDetailDTO) => {
    hotelDetail.value = val
  }
  const setIsClickRoomTypeBut = (val: boolean) => {
    isClickRoomTypeBut.value = val
  }

  return {
    selHotelRoom,
    rpIndex,
    hotelDetail,
    isClickRoomTypeBut,
    setSelHotelRoom,
    setRpIndex,
    setHotelDetail,
    setIsClickRoomTypeBut,
  }
})
